var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer8 = function SvgNumTimer8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M4.84 29q-1.68 0-2.471-.768-.768-.768-.768-2.472V21.2q0-1.536.72-2.256.744-.72 2.376-.72v-1.416q-1.656 0-2.376-.696t-.72-2.28V10.76q0-1.68.768-2.448.768-.792 2.472-.792h10.296q1.704 0 2.472.768.792.768.792 2.472v3.072q0 1.584-.744 2.28-.72.696-2.352.696v1.416q1.632 0 2.352.72.744.72.744 2.256v4.56q0 1.68-.768 2.472-.768.768-2.496.768zm8.953-3.888V19.4H6.209v5.712zm0-9.528v-4.176H6.209v4.176z"
  })));
};
export default SvgNumTimer8;